import React from 'react';
import { useStowageStore } from 'src/context/StowageContext';
import BottomTankPlanContextMenu from './BottomTankPlanContextMenu';
import { BottomTankPlanMenuWrapper } from './TankPlanTopMenu.styles';

const BottomTankPlanMenuWrapperComponent: React.FC = () => {
    const { tankPlanBottomContextMenuState } = useStowageStore();

    return (
        <BottomTankPlanMenuWrapper>
            {tankPlanBottomContextMenuState.visible && <BottomTankPlanContextMenu contextMenuState={tankPlanBottomContextMenuState} />}
        </BottomTankPlanMenuWrapper>
    );
};

export default BottomTankPlanMenuWrapperComponent;
